// ABOUTME: Keeps a jf-buy-row block's price line on the flavour picked in its select.
// The select itself is the form's variant id field, so the add posts the right flavour without this script; it only mirrors the price.
class JfBuyRow extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  /** @param {Event} event */
  #onChange = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.classList.contains('jf-buy-row__select')) return;

    const price = this.querySelector('.jf-buy-row__price');
    const option = select.selectedOptions[0];
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  };
}

if (!customElements.get('jf-buy-row')) {
  customElements.define('jf-buy-row', JfBuyRow);
}
